import React from 'react';

export default function Spacer({ orientation = 'horizontal', size = 10 }) {
    return (
        <div
            style={{
                display: 'flex',
                margin:
                    orientation === 'horizontal'
                        ? `${size}px 0px`
                        : `0px ${size}px`,
            }}
        />
    );
}
